<template>
  <div class="flex-wrapper">
    <v-select
      hide-details
      single-line
      dense
      light
      outlined
      append-icon="mdi-chevron-down"
      v-model="type"
      :items="filterType"
      style="width: 10rem;"
    />
    <div style="width: 9rem;" v-if="type.toLowerCase() === 'per tanggal'">
      <datepicker
        :clickCloseContent="false"
        dateFormat="DD/MM/YYYY"
        placeholder="Tanggal Awal"
        :show="showDatepicker"
        :date="startDate"
        @date-change="handleStartDateChange"
      />
    </div>
    <div class="flex-wrapper" v-if="type.toLowerCase() === 'rentang tanggal'">
      <div style="width: 9rem;">
        <datepicker
          :clickCloseContent="false"
          :max="endDate"
          dateFormat="DD/MM/YYYY"
          placeholder="Tanggal Awal"
          :show="showDatepicker"
          :date="startDate"
          @date-change="handleStartDateChange"
        />
      </div>
      <span>s.d.</span>
      <div style="width: 9rem;">
        <datepicker
          :clickCloseContent="false"
          :min="startDate"
          dateFormat="DD/MM/YYYY"
          placeholder="Tanggal Akhir"
          :show="showDatepicker"
          :date="endDate"
          @date-change="handleEndDateChange"
        />
      </div>
    </div>
    <div class="flex-wrapper" v-if="type.toLowerCase() === 'per bulan'">
      <div style="width: 8rem;">
        <datepicker
          :clickCloseContent="false"
          dateFormat="MM/YYYY"
          typeDate="month"
          :show="showDatepicker"
          :date="startDate"
          @date-change="handleStartDateChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '../Datepicker/Datepicker.vue';
const moment = require('moment');
export default {
  name: 'DynamicDatepicker',
  components: { Datepicker },
  props: {
    defaultType: {
      type: String,
      default: 'Per Tanggal',
    },
    filterType: {
      type: Array,
      default: () => [],
    },
    defaultDate: {
      type: String,
      default: moment().format('YYYY-MM-DD'),
    },
  },
  watch: {
    type: {
      handler(newVal) {
        if (newVal.toLowerCase() === 'rentang tanggal') {
          this.startDate = '';
          this.endDate = '';
          this.$emit('date-change', {
            startDate: '',
            endDate: '',
            changedByWatch: true,
          });
        } else if (newVal.toLowerCase() === 'semua waktu') {
          this.startDate = '';
          this.endDate = '';
          this.$emit('date-change', {
            startDate: '',
            endDate: '',
          });
        } else {
          this.startDate = moment().format('YYYY-MM-DD');
          this.$emit('date-change', {
            changedByWatch: true,
          });
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      type: this.defaultType,
      showDatepicker: false,
      startDate: this.defaultDate,
      endDate: this.defaultDate,
    };
  },
  methods: {
    handleStartDateChange(updatedDate) {
      this.startDate = updatedDate;
      if (this.type.toLowerCase() === 'per bulan') {
        this.$emit('date-change', {
          startDate: moment(this.startDate)
            .startOf('month')
            .format('YYYY-MM-DD'),
          endDate: moment(this.startDate)
            .endOf('month')
            .format('YYYY-MM-DD'),
        });
      } else {
        this.$emit('date-change', {
          startDate: this.startDate,
          endDate:
            this.type.toLowerCase() === 'per tanggal' ? '' : this.endDate,
        });
      }
    },
    handleEndDateChange(updatedDate) {
      this.endDate = updatedDate;
      this.$emit('date-change', {
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-list-item .v-list-item__content {
  line-height: 1.1;
  flex: 1 0 100%;
  text-align: start;
}
.flex-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
</style>
